export default "__VITE_ASSET__BnrN$Jx7__"